import { DropdownMenu as DropdownMenuPrimitive } from "radix-ui";

export const DropdownMenuRoot = DropdownMenuPrimitive.Root;
